import { useRef, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';
import { useClickAway } from 'react-use';
import { itemSettingStyle, lineHeightStyle } from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';
import SelectedItemSearch from './selectedItemSearch';

const Observation = ({
  deletePrescriptionItem,
  selectedOnExamination,
  setSelectedOnExamination,
  prescriptionItems,
  isHistoryPage,
}) => {
  const [isEdit, setIsEdit] = useState('');

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsEdit('');
  });

  const handleNoteOfObservation = (item, fieldName, val) => {
    const objIndex = selectedOnExamination?.observations.findIndex(
      (data) => data.name === item.name,
    );

    if (objIndex !== -1) {
      const updatedData = [...selectedOnExamination?.observations];
      updatedData[objIndex] = {
        ...updatedData[objIndex],
        [fieldName]: val,
      };

      setSelectedOnExamination({
        ...selectedOnExamination,
        observations: updatedData,
      });
    }
  };

  const editMode = (item) => {
    return (
      <Row ref={ref} className="selected-row-edit" key={`${item.name}`}>
        <Col className="pr-0 pl-0">
          <SelectedItemSearch
            apiUrl="observations"
            selectedItemName={item.name}
            selectedItems={selectedOnExamination}
            selectedItemsAction={setSelectedOnExamination}
            observation={true}
          />
        </Col>
        <Col md={2}>
          <Form.Select
            className="form-control form-control-sm"
            value={item.side || ''}
            onChange={(e) =>
              handleNoteOfObservation(item, 'side', e.target.value)
            }
          >
            <option value="">Side</option>
            <option value="rt">RT</option>
            <option value="lt">LT</option>
            <option value="bil">BIL</option>
          </Form.Select>
        </Col>
        <Col className="pl-0 pr-0">
          <TextareaAutosize
            minRows={1}
            maxRows={3}
            className="text-editor-edit"
            placeholder="Add Note"
            value={item.note || ''}
            onChange={(e) =>
              handleNoteOfObservation(item, 'note', e.target.value)
            }
          />
        </Col>
        <Col md={1} style={{ textAlign: 'right' }}>
          <i
            className="fa fa-times-circle"
            aria-hidden="true"
            onClick={() => setIsEdit('')}
          ></i>
        </Col>
      </Row>
    );
  };

  return (
    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
      {selectedOnExamination?.observations?.map((item, index) => (
        <li key={index} style={{ position: 'relative' }}>
          <div onClick={() => setIsEdit(index)}>
            <span
              style={itemSettingStyle(
                prescriptionItems?.items?.['on-examination']?.itemStyle || {},
              )}
            >
              {item.name ? ` ${item.name}` : ''}
              {item?.side ? ` - ${item?.side?.toUpperCase()}` : ''}
            </span>

            {item?.note && (
              <div
                className="pl-2 preline ovation-list"
                style={itemSettingStyle(
                  prescriptionItems?.items?.['on-examination']?.subItemStyle ||
                    {},
                )}
              >
                - {item?.note}
              </div>
            )}
          </div>

          {!isHistoryPage && (
            <CommonDeleteBtn
              action={deletePrescriptionItem}
              itemName="onExamination"
              delId={item.name}
            />
          )}
          {index === isEdit && editMode(item)}
        </li>
      ))}
    </ul>
  );
};

export default Observation;
